import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getHomeOccupationStart,
  getHomeOccupationSuccess,
  getHomeOccupationFailure,
} from "../reducers/getHomeOccupationReducer";
import axios from "axios";
import Cookies from "js-cookie";
import { getToken } from "./getToken";

export const getHomeOccupation = createAsyncThunk(
  "getHomeOccupation",
  async (_, thunkAPI) => {
    try {
      thunkAPI.dispatch(getHomeOccupationStart());
      const token = Cookies.get("token");

      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}api/Home/GetOccupations`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const responseData = await response;

      thunkAPI.dispatch(getHomeOccupationSuccess(responseData?.data?.result));

      return responseData;
    } catch (error) {
      thunkAPI.dispatch(getHomeOccupationFailure(error.response.data.Message));
      if (error.response && error.response.status === 401) {
        Cookies.remove("token");

        thunkAPI.rejectWithValue({ unauthorized: true });
        await thunkAPI.dispatch(getToken());
      }
      throw error;
    }
  }
);
